






























import Vue from "vue"
import Sel from "./components/Sel.vue"
import Sdr from "./components/Sdr.vue"
import Help from "./components/Help.vue"
import { Bag } from "./components/Common"

export default Vue.extend({
    name: "App",

    components: {
        Sel,
        Sdr,
        Help
    },

    data: () => ({
        loading: false,
        page: "sel",
        bag: {} as Bag
    }),
    methods: {
        switch_page(page: string) {
            this.page = page
        }
    },
    created() {
        // test slow loading
        // setTimeout(() => {
        //   this.loading = false
        // }, 5000);
    }
})
